import React from 'react';
import { useBookingEditText } from "../text";
import Dropdown from '../../../../components/ui/Dropdown';
import { cn } from '../../../../utils/classnames';
import { createTypographyHelper } from '../../../../utils/typography';
// import LuggageIcon from '../../../../icons/form-icons/luggage.svg';
import { LuggageIcon } from '../../../icons';

const LuggageDropdown = ({ luggage, setLuggage, label = "Luggage" }) => {
  const { t, language } = useBookingEditText();
  const getTypographyClass = createTypographyHelper(language);

  const luggageTypes = [
    { key: 'cabin', label: t("editBooking.BookingEditPage.basicInformation.luggageType.cabinSize"), subtitle: t("editBooking.BookingEditPage.basicInformation.luggageType.cabinSizeSubtitle") },
    { key: 'checkin', label: t("editBooking.BookingEditPage.basicInformation.luggageType.checkInSize"), subtitle: t("editBooking.BookingEditPage.basicInformation.luggageType.checkInSizeSubtitle") }
  ];

  const getTotalLuggage = () => {
    return Object.values(luggage).reduce((sum, val) => sum + val, 0);
  };

  const getLuggageDisplayText = () => {
    const parts = Object.entries(luggage)
      .filter(([_, value]) => value > 0)
      .map(([key, value]) => {
        const label = luggageTypes.find(t => t.key === key)?.label.split(' ')[0];
        return `${label}: ${value}`;
      });
    return parts.join(', ') || t("editBooking.BookingEditPage.basicInformation.luggagePlaceholder");
  };

  const handleChange = (type, increment) => {
    const newValue = increment
      ? luggage[type] + 1
      : Math.max(0, luggage[type] - 1);
    setLuggage({ ...luggage, [type]: newValue });
  };

  const renderCounter = ({ key, label, subtitle }) => {
    const value = luggage[key];
    const isZero = value === 0;

    return (
      <div key={key} className="tw:flex tw:items-center tw:justify-between">
        <div className="tw:flex tw:flex-col">
          <div className={`tw:text-[#212529] ${getTypographyClass(14)}`}>
            {label}
          </div>
          {subtitle && (
            <div className={`tw:text-[#8d8d8d] ${getTypographyClass(12)}`}>
              {subtitle}
            </div>
          )}
        </div>
        <div className="tw:flex tw:items-center tw:gap-3">
          <button
            type="button"
            onClick={() => handleChange(key, false)}
            disabled={isZero}
            className="tw:w-[32px] tw:h-[32px]"
          >
            <span className={cn(`tw:rounded-full tw:border tw:border-[#dbbe78] tw:flex tw:items-center tw:justify-center tw:w-full tw:h-full tw:transition-colors tw:text-[16px] tw:font-normal ${isZero
              ? 'tw:bg-white tw:text-[#a7a7a7] tw:opacity-40 tw:cursor-not-allowed'
              : 'tw:bg-[#f9edd3] tw:text-[#282828] hover:tw:bg-gray-50'
              }`)}>−</span>
          </button>
          <div className={`tw:w-[40px] tw:text-center tw:text-[#212529] ${getTypographyClass(14)}`}>
            {value}
          </div>
          <button
            type="button"
            onClick={() => handleChange(key, true)}
            className="tw:w-[32px] tw:h-[32px]"
          >
            <span className="tw:rounded-full tw:border tw:border-[#dbbe78] tw:flex tw:items-center tw:justify-center tw:w-full tw:h-full tw:bg-[#f9edd3] tw:text-[#282828] hover:tw:bg-[#f5e6bc] tw:transition-colors tw:text-[16px] tw:font-normal">+</span>
          </button>
          {/* <button
            type="button"
            onClick={() => handleChange(key, true)}
            className="tw:w-[32px] tw:h-[32px] tw:rounded-full tw:border tw:border-[#dbbe78] tw:flex tw:items-center tw:justify-center tw:bg-[#f9edd3] tw:text-[#282828] hover:tw:bg-[#f5e6bc] tw:transition-colors"
          >
            <span className="tw:text-[18px] tw:font-bold tw:leading-none tw:font-hanken-grotesk">+</span>
          </button> */}
        </div>
      </div>
    );
  };

  return (
    <Dropdown
      label={label}
      displayValue={getLuggageDisplayText()}
      getTypographyClass={getTypographyClass}
      placeholder={t("editBooking.BookingEditPage.basicInformation.luggagePlaceholder")}
      fieldIcon={<LuggageIcon/>}
      borderColor="#e8e8e8"
    >
      <div className="tw:flex tw:flex-col tw:gap-3">
        <div className={`tw:font-bold tw:text-[#212529] ${getTypographyClass(16)}`}>
          {t("editBooking.BookingEditPage.basicInformation.luggage")}
        </div>
        <div className="tw:flex tw:flex-col tw:gap-3">
          {luggageTypes.map(renderCounter)}
        </div>
      </div>
    </Dropdown>
  );
};

export default LuggageDropdown;
